import axios from 'axios';
import { API_ENDPOINTS } from '../../apiConfig';

// DTO for creating/updating a reminder
export interface ReminderDTO {
  id?: string;
  tenantId: string;
  name: string;
  description?: string;
  startTime: string;
  endTime?: string;
  active: boolean;
  frequency: string; // DAILY, WEEKLY, etc.
  channels: string[];
  userIds: number[];
  entityType: string;
  entityId: string;
  specificDaysOfWeek?: number[];
  specificDaysOfMonth?: number[];
  interval?: number;
  nextReminderTime?: string;
}

// For filtering/search
export type ReminderFilterDTO = Partial<Omit<ReminderDTO, 'channels' | 'userIds'>>;

const API_BASE = `${API_ENDPOINTS.common}/reminders`;

export const ReminderApi = {
  create: (data: ReminderDTO) => axios.post(`${API_BASE}`, data),
  update: (id: string, data: ReminderDTO) => axios.put(`${API_BASE}/${id}`, data),
  delete: (id: string) => axios.delete(`${API_BASE}/${id}`),
  getById: (id: string) => axios.get<ReminderDTO>(`${API_BASE}/${id}`),
  filter: (filter: ReminderFilterDTO) => axios.post(`${API_BASE}/search`, filter),
};